/*       */

import { combineReducers } from 'redux';

import {
    LOAD_EVENTS_STARTED,
    LOAD_EVENTS,
    LOAD_SIDEBAR_EVENT_DETAILS_STARTED,
    LOAD_SIDEBAR_EVENT_DETAILS,
    LOAD_EVENT_DETAILS_STARTED,
    LOAD_EVENT_DETAILS,
    LOAD_EVENT_TYPES_STARTED,
    LOAD_EVENT_TYPES,
    LOAD_EVENT_TYPE_DETAILS_STARTED,
    LOAD_EVENT_TYPE_DETAILS,
    LOAD_EVENT_TYPE_DATA_ATTRIBUTES_STARTED,
    LOAD_EVENT_TYPE_DATA_ATTRIBUTES,
} from 'store/actions/stream/eventsActions';
import { dataTableReducer, loadDataReducer, keepDataAtStart } from 'app/utils/redux/reducer-utils';

import processes from 'store/reducers/stream/events/processes/eventProcessesReducer';

const initialState = {
    records: [],
    eventMap: {},
    isLoading: false
};

const eventsMapReducer = (state = initialState, action) => {
    const { payload } = action;
    const { eventTypeId, ...meta } = action?.meta || {};
    let updatedState = { ...state };
    const updatedEventMap = { ...state?.eventMap };
    
    switch (action?.type) {
        case LOAD_EVENTS_STARTED:
            if (eventTypeId) {
                updatedEventMap[eventTypeId] = { isLoading: true, ...meta };
            } else {
                updatedState = { ...updatedState, isLoading: true, ...meta };
            }
            return { ...updatedState, eventMap: updatedEventMap };
        case LOAD_EVENTS:
            if (eventTypeId) {
                updatedEventMap[eventTypeId] = { ...payload, isLoading: false, ...meta };
            } else {
                updatedState = {
                    ...updatedState,
                    ...payload,
                    isLoading: false,
                    ...meta
                };
            }
            return { ...updatedState, eventMap: updatedEventMap };
        default:
            return state;
    }
};

export default combineReducers({
    processes,
    list: eventsMapReducer,
    types: dataTableReducer(LOAD_EVENT_TYPES_STARTED, LOAD_EVENT_TYPES, keepDataAtStart),
    typeData: loadDataReducer(LOAD_EVENT_TYPE_DETAILS_STARTED, LOAD_EVENT_TYPE_DETAILS, keepDataAtStart),
    attributesData: loadDataReducer(LOAD_EVENT_TYPE_DATA_ATTRIBUTES_STARTED, LOAD_EVENT_TYPE_DATA_ATTRIBUTES, keepDataAtStart),
    details: loadDataReducer(LOAD_EVENT_DETAILS_STARTED, LOAD_EVENT_DETAILS),
    sidebar: combineReducers({
        details: loadDataReducer(LOAD_SIDEBAR_EVENT_DETAILS_STARTED, LOAD_SIDEBAR_EVENT_DETAILS),
    }),
});
